export default __webpack_public_path__ + "static/media/loggedVerify.f2d1eafb.svg";